import { Container } from './styles'
import foto from '../../assets/kelvyn.jpeg'
import github from '../../assets/github.png'
import linkedin from '../../assets/linkedin.png'
import insta from '../../assets/insta.png'
import email from '../../assets/image.png'
import whatsapp from '../../assets/whatsapp.png'

export default function Header() {
  return (
    <Container>
      <>
        {/* <section>oi</section> */}
        <article className='container'>
          <div className='box'>
            <section className='name'>
              <h1>Olá, sou o Kelvyn Khrystian</h1>
            </section>
            <section className='infos'>
              {' '}
              <div className='img-box'>
                <img src={foto} alt='kelvyn khrystian' />
              </div>
              <div className='info-box'>
                <p> • Dev Web FullStack</p>
                <p> • Foco em React e Node</p>
                <p> • Atualmente: Freelancer</p>
                <p> • Mais informações abaixo</p>
              </div>
            </section>
            <section className='links'>
              <a href='https://github.com/kelvynkhrystian' target='_blank' rel='noreferrer'>
                <img src={github} alt='logo-github' />
              </a>
              <a
                href='https://www.linkedin.com/in/kelvynkhrystian/'
                target='_blank'
                rel='noreferrer'
              >
                <img src={linkedin} alt='logo-linkedin' />
              </a>
              <a href='https://www.instagram.com/kelvyn_kk/' target='_blank' rel='noreferrer'>
                <img src={insta} alt='logo-insta' />
              </a>
              <a
                href='https://api.whatsapp.com/send?phone=5598991054292&text=Kelvyn+Khrystian%0D%0ADesenvolvedor+WEB'
                target='_blank'
                rel='noreferrer'
              >
                <img src={whatsapp} alt='logo-whatsapp' />
              </a>
              <a href='mailto:khrystian.dev@hotmail.com' target='_blank' rel='noreferrer'>
                <img src={email} alt='logo-outlook' />
              </a>
            </section>
          </div>
        </article>
      </>
    </Container>
  )
}
